import script from "./BankingDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BankingDetails.vue?vue&type=script&setup=true&lang=js"

import "./BankingDetails.vue?vue&type=style&index=0&id=6fb7bb4d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb7bb4d"]])

export default __exports__